import React, { Component } from 'react';
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";
import config from "../config";


export default class Home extends Component {
    static contextType = AuthContext
    constructor(props, context) {
        super(props);
        this.authContext = context;
    }

    render() {
        return (
            <div>
                <div className="card shadow w100">
                    <div className="card-header py-3"><h2 className="m-0 font-weight-bold"> Home</h2></div>
                    <div className="card-body">

                    </div>
                </div>
            </div>
        );
    }
}

